import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from 'api/Utils';



export function getViewAovProgressBarOverview(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/aov-progress-bar-overview`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


export function getViewAovProgressBarConnections(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/aov-progress-bar-connections`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathViewAovProgressBarEditor(apbId=null) {
  if (apbId) {
      return `view/extensions/aov-progress-bar-editor/${apbId}`;
  } else {
      return `view/extensions/aov-progress-bar-editor`;
  }
}

export function getViewAovProgressBarEditor(successCallback, errorCallback, apbId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewAovProgressBarEditor(apbId), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathAovProgressBars(apbId=null) {
  if (apbId) {
      return `extensions/aov-progress-bars/${apbId}`;
  } else {
      return `extensions/aov-progress-bars`;
  }
}

export function createAovProgressBars(successCallback, errorCallback, data) {
  postAuth({
    "path": pathAovProgressBars(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchAovProgressBars(successCallback, errorCallback, data, apbId) {
  patchAuth({
    "path": pathAovProgressBars(apbId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteAovProgressBars(successCallback, errorCallback, apbId) {
  deleteAuth({
    "path": pathAovProgressBars(apbId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

